"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.selectProfilePicture = selectProfilePicture;
exports.selectCurrentUserProfilePicture = selectCurrentUserProfilePicture;
exports.selectProfilePicturesMap = selectProfilePicturesMap;
/* eslint-disable @typescript-eslint/no-explicit-any */
var immutable_1 = require("immutable");
var config_1 = require("config");
var config = (0, config_1.get)();
var communityProfileEnabled = !!(config && config.features
    && config.features.communityProfile);
var EMPTY_PICTURE = { url: '', small: '', card: '' };
var EMPTY_MAP = (0, immutable_1.Map)();
/**
 * Select a profile picture for a given uid from the GraphQL lookup table.
 *
 * Feature-flag gated:
 *   ON  → returns { url, small, card } (empty strings if not yet loaded)
 *   OFF → returns null (callers use their existing REST paths)
 */
function selectProfilePicture(state, uid) {
    if (!communityProfileEnabled)
        return null;
    if (!uid)
        return EMPTY_PICTURE;
    var key = String(uid);
    var gql = state.communityProfile.getIn(['profilePictures', 'data', key]);
    if (gql && gql.size > 0) {
        return gql.toJS();
    }
    return EMPTY_PICTURE;
}
/**
 * Shorthand selector for the current user's profile picture.
 */
function selectCurrentUserProfilePicture(state) {
    var uid = state.auth.get('uid');
    return selectProfilePicture(state, uid);
}
/**
 * Select the entire profilePictures lookup Map for multi-profile components.
 *
 * Feature-flag gated:
 *   ON  → returns Immutable Map keyed by uid string
 *   OFF → returns empty Map (callers fall back to REST paths)
 */
function selectProfilePicturesMap(state) {
    if (!communityProfileEnabled)
        return EMPTY_MAP;
    return state.communityProfile.getIn(['profilePictures', 'data'], EMPTY_MAP);
}
